<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_x"></a><a id="page_1"></a><a id="int"></a><strong>Introduction</strong></h2>
<h2 class="h2d"><strong>Enjoy every precious moment!</strong></h2>
<p class="noindent">These four words have become a basic creed for me, a reminder that this gift called life is truly an extraordinary honor and opportunity. Every letter I write and every voice-mail message I leave end with this simple statement. And nearly every day someone responds to these four words with sincere thanks because they awaken feelings of love, joy, and gratitude, shattering the numbness and “taking-for-granted” attitude that sometimes seep into our souls.</p>
<p class="indent">The decision to embrace every moment as a precious gift is ultimately a choice of love over fear. The impact of that choice can be so profound, so transformational, that it changes your perspective, your presence, and your peace of mind forever. You will see beauty, hope, and opportunity where you would have completely missed them before making this pivotal choice. You will find yourself connecting with people you might have avoided before, even the people you’re pretty certain were put on the planet to “test” you. You will recognize that material possessions do not make the biggest difference; the spirit and heart you bring to each day ultimately determine the quality of your life and the lasting effect you have on others. This book will offer you new choices to enrich every moment—to build a truly joyful spirit.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?73c8de62